"use strict";

import "whatwg-fetch";

import { optionsGen } from "../helpers/api";
import { toTitleCase } from "../helpers/converters";
import { API_URL } from "../config";
import { toESQuery, toESGroupByQuery, toESDateHistogramQuery, toESDateHistogramGroupByQuery } from "../helpers/query";

const AUTH = false;
export const REEXAM_URL = `${API_URL}/prosecution/`;
export const REEXAM_SEARCH_URL = `${API_URL}/patents/prosecution/_search`;

export const scopeQuery = query => ({ ...query, series_code: 90 }); // ex-parte reexam apps only

export function esqCases(query, highlight = false) {
  return toESQuery(scopeQuery(query), [], 20, highlight);
}

export function getCases(query) {
  return fetch(REEXAM_SEARCH_URL, optionsGen("POST", esqCases(query), AUTH)).then(resp => resp.json());
}

export function getDistinctValues(field, query) {
  const queries = scopeQuery(query);
  return fetch(REEXAM_SEARCH_URL, optionsGen("POST", toESGroupByQuery(field, queries, 50), AUTH))
    .then(resp => resp.json())
    .then(json => {
      return json.aggregations[field].buckets.map(e => toTitleCase(e.key));
    });
}

export function getCaseDetail(casenum) {
  return fetch(`${REEXAM_URL}${casenum}`, optionsGen("GET", false, AUTH)).then(resp => resp.json());
}

export function countCasesByField(query, field, size = 20) {
  const queries = scopeQuery(query);
  return fetch(REEXAM_SEARCH_URL, optionsGen("POST", toESGroupByQuery(field, queries, size), AUTH))
    .then(resp => resp.json())
    .then(json => {
      let total = json.aggregations[field].sum_other_doc_count;
      json.aggregations[field].buckets.forEach(b => {
        total += b.doc_count;
      });
      return json.aggregations[field].buckets.map(b => ({
        ...b,
        doc_pct: b.doc_count / total
      }));
    });
}

export function countCasesByDate(query, dateField, interval = "year") {
  const queries = scopeQuery(query);
  return fetch(REEXAM_SEARCH_URL, optionsGen("POST", toESDateHistogramQuery(dateField, interval, queries), AUTH))
    .then(resp => resp.json())
    .then(json => {
      return json.aggregations[dateField].buckets;
    });
}

export function countCasesByDateAndField(query, dateField, field2, interval = "year") {
  const queries = scopeQuery(query);
  let q = toESDateHistogramGroupByQuery(dateField, field2, interval, queries);
  return fetch(REEXAM_SEARCH_URL, optionsGen("POST", q, AUTH))
    .then(resp => resp.json())
    .then(json =>
      json.aggregations[dateField].buckets.map(b => ({
        key: b.key,
        key_as_string: b.key_as_string,
        value: b[field2].buckets.map(bb => ({
          key: bb.key,
          doc_count: bb.doc_count
        }))
      }))
    );
}

export function getCasesByField(query, field, labelMap, mergeThreshold = 0.01) {
  const queries = scopeQuery(query);
  return fetch(REEXAM_SEARCH_URL, optionsGen("POST", toESGroupByQuery(field, queries, 50)))
    .then(resp => resp.json())
    .then(json => {
      const total = json.hits.total.value;
      let otherCount = json.aggregations[field].sum_other_doc_count || 0;
      let res = {};
      let keyCountPairs = json.aggregations[field].buckets;
      keyCountPairs.forEach(e => {
        const key = toTitleCase(e.key);
        const label = labelMap ? labelMap[key] || key : key;
        // put fractions less than `mergeThreshold` into `Other`
        if (e.doc_count / total >= mergeThreshold) {
          res[label] = e.doc_count;
        } else {
          otherCount += e.doc_count;
        }
      });
      if (otherCount > 0) {
        res.Other = otherCount;
      }
      return res;
    });
}
